/** Exact self-hosted MSB faces; source rendering and native asset builds share inventory. */
export const MSB_FONT_FILES = [
  {id:'msb-paperlogy-400',file:'fonts/Paperlogy-4Regular.woff2',family:'Paperlogy',weight:400},
  {id:'msb-paperlogy-500',file:'fonts/Paperlogy-5Medium.woff2',family:'Paperlogy',weight:500},
  {id:'msb-paperlogy-600',file:'fonts/Paperlogy-6SemiBold.woff2',family:'Paperlogy',weight:600},
  {id:'msb-paperlogy-700',file:'fonts/Paperlogy-7Bold.woff2',family:'Paperlogy',weight:700},
  {id:'msb-paperlogy-800',file:'fonts/Paperlogy-8ExtraBold.woff2',family:'Paperlogy',weight:800},
] as const;
